module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.3cf6adf6.woff";